export default __webpack_public_path__ + "static/media/edit-alt.e9942aac.svg";